import Background from './Background';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import mixin from '../privates/utils/mixin';

 /**
 * @class MediaBox
 * @summary A container for media items.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.Background
 * @memberof $w
 * @queryable
 * @tagname mediaBox
 * @viewername wysiwyg.viewer.components.MediaBox
 * @definitionId wysiwyg.viewer.components.MediaBox
 */

class MediaBox extends Background {}

mixin(MediaBox.prototype, HiddenCollapsedMixin.prototype);

export default MediaBox;
